module.exports = __webpack_public_path__ + "static/media/segoeui-regular.a66ac4b2.woff2";